module.exports = __webpack_public_path__ + "static/media/postgresqlchina.81144444.jpg";